import { BackendApi } from "./HttpBaseService";

const ObtenerConcursoActual = async () => {
  return await BackendApi.get(`Concurso/Actual`);
};

const ObtenerConcursos = async () => {
  return await BackendApi.get(`Concurso/Todos`);
};

const CrearConcurso = async concurso => {
  return await BackendApi.post(`Concurso/Crear`, concurso);
};

const EliminarConcurso = async id => {
  return await BackendApi.delete(`Concurso/Eliminar?id=${id}`);
};

const ModificarConcurso = async (id, concurso) => {
  return await BackendApi.put(`Concurso/${id}/Modificar`, concurso);
};

const ObtenerEtapas = async id => {
  return await BackendApi.get(`Concurso/${id}/Etapas`);
};

const CargarEtapaConcurso = async etapa => {
  return await BackendApi.post(`Concurso/CargarEtapa`, etapa);
};

const ObtenerEtapaPorId = async id => {
  return await BackendApi.get(`Concurso/EtapaPorId/${id}`);
};

const ObtenerConcursoPorId = async id => {
  return await BackendApi.get(`Concurso/${id}`);
};

const GuardarClasificadosLiguilla = async (id, clasificadosLiguilla) => {
  return await BackendApi.put(
    `Concurso/${id}/ClasificadosLiguilla`,
    clasificadosLiguilla
  );
};

const ObtenerResultadosConcurso = async id => {
  return await BackendApi.get(`Concurso/${id}/Resultados`);
};

const GuardarResultadosConcurso = async (id, resultados) => {
  return await BackendApi.put(`Concurso/${id}/GuardarResultados`, resultados);
};

const ModificarConcursoEstado = async (id, estado) => {
  return await BackendApi.put(
    `Concurso/${id}/ModificarEstado?concursoEstadoId=${estado}`
  );
};

// Herramienta de recuperación para un concurso que quedó en
// ResultadosDisponibles con las pencas sin calcular (bloqueada en
// Production del lado del backend, ver ConcursoController).
const RecalcularResultadosPenca = async id => {
  return await BackendApi.post(`Concurso/${id}/RecalcularResultadosPenca`);
};

const ObtenerClasificadosLiguilla = async id => {
  return await BackendApi.get(`Conjunto/ClasificadosLiguilla`);
};

const ValidarTemporada = async id => {
  return await BackendApi.get(`AppUtils/validar-temporada/${id}`);
};

const ObtenerVistaPreviaTransicion = async id => {
  return await BackendApi.get(`Concurso/${id}/VistaPreviaTransicion`);
};

const ObtenerCandidatosTemporada = async () => {
  return await BackendApi.get(`Concurso/CandidatosTemporada`);
};

const ObtenerVistaPreviaHabilitarTemporada = async id => {
  return await BackendApi.get(`Concurso/${id}/VistaPreviaHabilitarTemporada`);
};

// M1-07 / DP-21: foto de los conjuntos de la edición (ConjuntoHistorico).
const CerrarEdicion = async id => {
  return await BackendApi.put(`Concurso/${id}/CerrarEdicion`);
};

const HabilitarComoActual = async id => {
  return await BackendApi.put(`Concurso/${id}/HabilitarComoActual`);
};

const SuspenderEtapa = async (etapaId, nuevaFecha) => {
  return await BackendApi.put(`Concurso/Etapa/${etapaId}/Suspender`, {
    nuevaFecha
  });
};

const CorrerInicioRueda = async (concursoId, ruedaConcursoId, nuevaFechaInicio) => {
  return await BackendApi.put(
    `Concurso/${concursoId}/Rueda/${ruedaConcursoId}/CorrerInicio`,
    { nuevaFechaInicio }
  );
};

const ConcursoService = {
  ObtenerConcursoActual,
  ObtenerConcursos,
  CrearConcurso,
  EliminarConcurso,
  ModificarConcurso,
  ObtenerEtapas,
  CargarEtapaConcurso,
  ObtenerEtapaPorId,
  ObtenerConcursoPorId,
  GuardarClasificadosLiguilla,
  ObtenerResultadosConcurso,
  GuardarResultadosConcurso,
  ModificarConcursoEstado,
  RecalcularResultadosPenca,
  ObtenerClasificadosLiguilla,
  ValidarTemporada,
  ObtenerVistaPreviaTransicion,
  ObtenerCandidatosTemporada,
  ObtenerVistaPreviaHabilitarTemporada,
  CerrarEdicion,
  HabilitarComoActual,
  SuspenderEtapa,
  CorrerInicioRueda
};

export default ConcursoService;
